import clsx from 'clsx'
import React, { FC } from 'react'

import { HeartFilled } from '@Components/SVG/Cache'

import styles from './WishlistButton.module.scss'

interface WishlistButtonProps {
  animated?: boolean
  className?: string
  label?: string
  onClick: (event) => void
  selected: boolean
  small?: boolean
}

export const WishlistButton: FC<WishlistButtonProps> = ({
  animated = true,
  className,
  label,
  onClick,
  selected,
  small,
}) => (
  <button
    aria-label={label}
    className={clsx(
      styles.wishlistButton,
      className,
      small && styles.small,
      !small && styles.default,
    )}
    onClick={onClick}
    type="button"
  >
    <div className={styles.box}>
      <HeartFilled className={clsx(styles.heart, selected && styles.selectedHeart, selected && 'selectedHeart', animated && styles.animated)} />
    </div>
  </button>
)
